module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-41.5177ac67.png";